module.exports = __webpack_public_path__ + "static/MUL_Icon.56d15146.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/MUL_Icon.jpg
// module id = 404
// module chunks = 29546219236060 61549186969478 213534597649335